export default {
    'create-financial-file': 'Crear archivo financiero',
    'create-backup': 'Crear copia de seguridad',
    'edit-financial-file': 'Editar archivo financiero',
    save: 'Guardar',
    cancel: 'Cancelar',

    confirm: 'Seguimiento',
    'browse-content': 'Explorar contenido',

    'do-you-want-to-change-the-current-financial-file': '¿Está seguro de que desea cambiar el archivo financiero actual?',

    'rotated-to-$': 'Trasladado a {financialFile}',
    rotated: 'Cerrado',
    locked: 'Cerrado',
    unlocked: 'No cerrado',

    'the-users-of-the-file-$-and-their-permissions': '{financialFile} Usuarios de Archivos y sus permisos',

    permissions: {
        title: 'Permisos',
        'no-permissions': 'No permisos',
        viewer: 'Permiso de sólo lectura',
        accountant: 'Contador',
        'warehouse-keeper': 'Encargada de almacén',
        'warehouse-manager': 'Jefe de almacén'
    },

    'the-logo-is-uploaded-successfully': 'El logotipo se ha adjuntado con éxito.'
}